
import React from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';

interface StudyContentProps {
  id: string;
  title: string;
  subtitle: string;
  content: React.ReactNode;
}

export const StudyContent = ({ title, subtitle, content }: StudyContentProps) => {
  return (
    <Card className="bg-slate-800 border-slate-700 text-white mb-8 overflow-hidden">
      <CardHeader className="border-b border-slate-700 bg-slate-850">
        <CardTitle className="text-2xl md:text-3xl font-bold">{title}</CardTitle>
        <CardDescription className="text-gray-300 text-lg">
          {subtitle}
        </CardDescription>
      </CardHeader>
      <CardContent className="pt-6 pb-2 px-6 md:px-8">
        <div className="prose prose-invert max-w-none">
          {content}
        </div>
      </CardContent>
    </Card>
  );
};
